import { graphql } from "gatsby"
import isEmpty from "~/lib/isEmpty"

export type UDSBorderColorComponent = {
  __typename: string
  color:
    | "none"
    | "base"
    | "bolder"
    | "semantic-success"
    | "semantic-promotion"
    | "semantic-neutral"
    | "semantic-caution"
    | "semantic-danger"
}

// References the @ionos-web-design-system/core `--border-*` tokens directly instead
// of duplicating their hex values — the package's `@theme inline` mapping for these
// is broken (`--color--base` instead of `--color-border-base`, missing the "border"
// segment), so the equivalent `border-*` Tailwind classes don't compile. Using the
// underlying CSS variable keeps colors in sync with the design system (incl. theming)
// until that's fixed upstream.
export const BORDER_COLOR_VAR: Record<
  UDSBorderColorComponent["color"],
  string
> = {
  none: "",
  base: "var(--border-base)",
  bolder: "var(--border-bolder)",
  "semantic-success": "var(--border-semantic-success)",
  "semantic-promotion": "var(--border-semantic-promotion)",
  "semantic-neutral": "var(--border-semantic-neutral)",
  "semantic-caution": "var(--border-semantic-caution)",
  "semantic-danger": "var(--border-semantic-danger)",
}

/**
 * Returns the CSS var() token, `""` for explicit none, or `undefined` when not configured.
 * Always check with `!== undefined`, never with truthiness.
 */
export function getBorderColorVar(
  color?: UDSBorderColorComponent | null
): string | undefined {
  if (isEmpty(color)) {
    return undefined
  }

  return BORDER_COLOR_VAR[color.color]
}

export const query = graphql`
  fragment UDSBorderColor on GraphCmsSquidex_UdsBorderColorComponent {
    __typename
    color
  }
`

export const FRAGMENT_UDS_BORDER_COLOR = `
  fragment UDSBorderColor on UdsBorderColorComponent {
    __typename
    color
  }
`
